import config from "./configuration";
async function request(path, method = "GET", body, signal) {
  let token = "";
  try { token = JSON.parse(localStorage.getItem("userData") || "{}").token || ""; } catch (_) {}
  const response = await fetch(`${config.BASE_URL.replace(/\/$/, "")}/api/rejection-approvals${path}`, {
    method, signal, cache: "no-store", headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok || result.status !== 200) throw new Error(result.message || "Unable to load rejection approvals.");
  return result.data;
}
const service = {
  list: (filters, report, signal) => request(`${report ? "/report" : "/"}?${new URLSearchParams(filters)}`, "GET", undefined, signal),
  decide: (id, action, comments) => request(`/${encodeURIComponent(id)}/decision`, "POST", { action, comments }),
};
export default service;
